import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA3');

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCard
                theme="white"
                layout="top-center"
                title={t('title')}
                label={t('label')}
                pc="https://websiteoss.ecoflow.com/upload/image/1744164885363/charger_section4.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1744100404752/charger_section4_h5.jpg"
            />
        </div>
    );
}
